import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: (failureCount, err) => {
        // Never retry auth or validation errors; retry once on network/5xx
        const status = (err as { status?: number } | undefined)?.status ?? 0;
        if (status === 401 || status === 403 || status === 422) return false;
        return failureCount < 1;
      },
      refetchOnWindowFocus: false,
    },
  },
});
